import { createQueryKeys } from "@lukemorales/query-key-factory";

import { getStatesList } from "./api";

export const queries = createQueryKeys("states", {
  list: (isEligible?: boolean) => {
    return {
      queryKey: ["states", { isEligible }],
      queryFn: () => getStatesList(isEligible),
    };
  },
});
